import Footer from "../../components/Footer";
import Header from "../../components/Header";
import RevenueMatters from "../../components/Service/Subservice/revenue";
 
import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";

export default function RevenueMattersPage() {
    return (
        <>
            <Header/>
            <SubServiceBanner title={"Revenue Records & Land Management"}/>
            <RevenueMatters/>
            <Footer/>
        </>
    )
}